module.exports = __webpack_public_path__ + "assets/img/RM.9a098891.png";